import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/approvedHourActions';
import * as projectActions from '../constants/projectActions';

const approvedHourActions = {

    // TODO use approverName
    approve(approvedHoursID, timesheetID, projectKey, taskKey, approvedHourKey) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForApprovedHourState());

            request
                .post(env.tashi + '/timesheets/' + timesheetID + '/approveHours')
                .query({
                    hoursId: approvedHoursID
                })
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.approveHours({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(projectActions.approveHoursProject(projectKey, taskKey, approvedHourKey));
                        dispatch(actions.approveHours({ status: "success", data: {approvedHoursID, timesheetID} }));
                    } else {
                        dispatch(actions.approveHours({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    // TODO create backend logic
    cmlmLoadByWeek(week) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForApprovedHourState());

            request
                .get(env.tashi + '/approvedHours/search/cmlm_findByWeek')
                .accept('application/json')
                .query({
                    week: week
                })
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.cmlmLoadApprovedHoursWeek({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.approvedHours;

                    if (data) {
                        dispatch(actions.cmlmLoadApprovedHoursWeek({ status: "success", data: data }));
                    } else {
                        dispatch(actions.cmlmLoadApprovedHoursWeek({ status: "success", data: [] }));
                    }
                });
        };
    },

    countUnapproved() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForApprovedHourState());

            request
                .get(env.tashi + '/timesheets/countUnapprovedHours')
                .accept('application/json')
                .query()
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.countUnapprovedHoursWeek({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text);

                    if (data != null && data != undefined) {
                        dispatch(actions.countUnapprovedHoursWeek({ status: "success", data: data }));
                    } else {
                        dispatch(actions.countUnapprovedHoursWeek({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    create(approvedHours) {
        return dispatch => {
            dispatch(actions.setLoadingFlagForApprovedHourState());

            request
                .post(env.tashi + '/approvedHours')
                .send(approvedHours)
                .withCredentials()
                .accept('application/json')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.createApprovedHours({ status: "failure", data: err }));
                        return;
                    }

                    if (res.ok) {
                        dispatch(actions.createApprovedHours({ status: "success", data: approvedHours }));
                    } else {
                        dispatch(actions.createApprovedHours({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    pmoLoadApprovable() {
        return dispatch => {
            dispatch(actions.setLoadingFlagForApprovedHourState());

            request
                .get(env.tashi + '/approvedHours/search/findPendingApprovals')
                .accept('application/json')
                .withCredentials()
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.pmoLoadApprovableHours({ status: "failure", data: err }));
                        return;
                    }

                    let data = JSON.parse(res.text)._embedded.approvedHours;

                    if (data) {
                        dispatch(actions.pmoLoadApprovableHours({ status: "success", data: data }));
                    } else {
                        dispatch(actions.pmoLoadApprovableHours({ status: "success", data: [] }));
                    }
                });
        };
    },

    setCurrentApprovalWeek(week) {
      return dispatch => {
        dispatch(actions.setCurrentApprovalWeek(week));
      };
    }
};

export default approvedHourActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/approvedHourActionCreators.js
 **/